module.exports = __webpack_public_path__ + "static/media/volume.d583329a.png";